import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';

// IMPORTANT: `stylis` is pinned to 4.2.0 in package.json to match the exact
// version @emotion/cache depends on. Emotion compiles CSS with its own stylis
// instance, so a prefixer imported from a *different* stylis copy is fed
// element nodes it does not understand. 4.3.x added a `siblings` field, and its
// prefixer throws "Cannot read properties of undefined (reading 'push')" on any
// ::placeholder rule — which every MUI TextField emits. Do not bump stylis
// independently of @emotion/cache.
//
// Emotion resolves plugins as `options.stylisPlugins || defaultStylisPlugins`.
// An empty array is truthy, so passing [] silently drops prefixing altogether —
// both branches must list the prefixer explicitly.
export const createEmotionCache = (isRtl = false) =>
  createCache({
    key: isRtl ? 'mui-rtl' : 'mui',
    stylisPlugins: isRtl ? [prefixer, rtlPlugin] : [prefixer],
  });
